// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CardForm_container__2wQyM {\n  width: 304px;\n  margin: -8px 0px;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Stripe/CardForm.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".container {\n  width: 304px;\n  margin: -8px 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "CardForm_container__2wQyM"
};
export default ___CSS_LOADER_EXPORT___;
